import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import { SimTypography } from 'components/SimTypography';

const childJourney = [
	{
		title: 'Intake',
		subtitle: 'General information gathering & onboarding'
	},
	{
		title: 'Assessment',
		subtitle: 'Tests & screening for developmental delays'
	},
	{
		title: 'Plan',
		subtitle: 'Set development goals and therapeutic plan'
	},
	{
		title: 'Review',
		subtitle: 'Tracking progress and setting of renewed goals'
	},
	{
		title: 'Therapy',
		subtitle: 'Personalized therapy in a naturalistic, social settings'
	},
	{
		title: 'Advancement',
		subtitle: 'Integration into traditional schooling format'
	}
];

const SimChildJourney = () => {
	const theme = useTheme();
	return (
		<>
			{childJourney.map((item, idx) => (
				<Grid item xs={6} md={2} key={idx}>
					<Box width={1} height={1}>
						<Box display={'flex'} flexDirection={'column'} alignItems={'left'} paddingY={2}>
							<SimTypography
								variant={'h3'}
								sx={{ fontWeight: 700 }}
								align={'left'}
								color={theme.palette.primary.main}>
								{idx + 1}
							</SimTypography>
							<SimTypography variant={'h6'} sx={{ fontWeight: 500 }} align={'left'}>
								{item.title}
							</SimTypography>
							<SimTypography align={'left'} color='text.secondary'>
								{item.subtitle}
							</SimTypography>
						</Box>
					</Box>
				</Grid>
			))}
		</>
	);
};

export { SimChildJourney };
